// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4FEnM","disabled":"styles_disabled__1SvXL"};